import React from 'react'
import ContactHeading from '../components/ContactHeading'
import Styled from "styled-components"
import ContactForm from '../components/ContactForm';
function Contact() {
  return (
    <MainCont>
        <ContactHeading/>
        <ContactForm/>
  </MainCont>
)
}
const MainCont = Styled.div`
  background:#111111;
  height:fit-content;
  min-height:100vh;
  display:flex;
  flex-direction:column;
  padding-left:100px;
  overflow-x:hidden;
  padding-right:100px;
  animation:BottomToTop .9s ease-in-out;
  @media (max-width:768px){
    padding-bottom: 10vh;
    padding-left:0px;
    padding-right:0px;
  }
`;
export default Contact